import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { CheckboxGroup } from '@bingads-webui-react/checkbox';

import { CommentsField } from '@bingads-webui-campaign-react/recommendation-feedback-modal';
import {
  reasonsMapping,
  reasonsMappingNewI18n,
  reasonsMappingAutoApplyFeedback,
} from './dismiss-feedback-const';

export class DismissFeedbackForm extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    newI18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }),
    recommendationType: PropTypes.string.isRequired,
    changeState: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    rejectAutoApplySuggestedAds: PropTypes.bool,
    isAccountSettings: PropTypes.bool,
  };
  static defaultProps = {
    changeState: null,
    rejectAutoApplySuggestedAds: false,
    isAccountSettings: false,
    newI18n: {
      getString: _.noop,
    },
  };

  constructor(props) {
    super(props);
    if (!_.isUndefined(reasonsMappingNewI18n[props.recommendationType])) {
      this.useNewI18n = true;
      this.reasonWithNewI18n = reasonsMappingNewI18n[props.recommendationType];
    }
  }

  state = {
    reasonIds: [],
    reasonNote: '',
    notshowagain: false,
  };

  onReasonChange = (checked) => {
    this.setState({
      reasonIds: checked,
    }, this.submitStateChange);
  };

  onSubmit = () => {
    // todo: in discussion.
    const { reasonIds, reasonNote, notshowagain } = this.state;
    const expireTime = Date.now() + (notshowagain ? (30 * 24 * 60 * 60 * 1000) : 0);
    const reasons = _.map(reasonIds, id => (this.useNewI18n ?
      this.props.newI18n.getString(this.reasonWithNewI18n[id]) :
      this.props.i18n.getString(`Recommendation_Dismiss_Feedback_${id}`)));
    this.props.onSubmit({
      reason: JSON.stringify({ reasons, reasonNote, reasonIds }),
      preference: {
        type: this.props.recommendationType,
        expireTime,
      },
    });
  };

  onCommentChange = (value) => {
    this.setState({
      reasonNote: value,
    }, this.submitStateChange);
  };
  onPreferenceChange = (e) => {
    const { checked } = e.target;
    this.setState({
      notshowagain: checked,
    }, this.submitStateChange);
  };
  submitStateChange() {
    if (this.props.changeState) {
      const submitDisabled = !this.state.notshowagain && this.state.reasonNote === '' && _.isEmpty(this.state.reasonIds);
      this.props.changeState(submitDisabled);
    }
  }

  renderCheckbox = reasonId => (this.useNewI18n ?
    this.props.newI18n.getString(this.reasonWithNewI18n[reasonId]) :
    this.props.i18n.getString(`Recommendation_Dismiss_Feedback_${reasonId}`));

  renderReasons() {
    const { rejectAutoApplySuggestedAds, isAccountSettings } = this.props;
    let reasons = rejectAutoApplySuggestedAds ?
      undefined :
      reasonsMapping[this.props.recommendationType];
    if (isAccountSettings) {
      reasons = reasonsMappingAutoApplyFeedback;
    }
    if (_.isEmpty(reasons)) {
      return null;
    }
    return (
      <div className="reasons">
        <CheckboxGroup
          items={reasons}
          renderItem={this.renderCheckbox}
          getItemValue={_.identity}
          onChange={this.onReasonChange}
          checked={this.state.reasonIds}
        />
      </div>);
  }

  render() {
    const { i18n, rejectAutoApplySuggestedAds, isAccountSettings } = this.props;
    const submitDisabled = !this.state.notshowagain && this.state.reasonNote === '' && _.isEmpty(this.state.reasonIds);
    const title = rejectAutoApplySuggestedAds ?
      i18n.getString('Recommendation_Dismiss_Feedback_Popup_Title_NotToAutoApplySuggestedAds') :
      i18n.getString('Recommendation_Dismiss_Feedback_Popup_Title');
    const blurb = rejectAutoApplySuggestedAds ?
      i18n.getString('Recommendation_Dismiss_Feedback_Popup_Blurb_NotToAutoApplySuggestedAds') :
      i18n.getString('Recommendation_Dismiss_Feedback_Popup_Blurb');
    return (
      <div className="recommendation-dismiss-feedback-form">
        <h3>{title}</h3>
        <p>{blurb}</p>
        {this.renderReasons()}
        <div className="comments form-group">
          <CommentsField
            id="comments"
            value={this.state.reasonNote}
            onChange={this.onCommentChange}
            i18n={i18n}
            isProvideFeedbackOnly={false}
            isAccountSettings
          />
        </div>

        <div className="actions form-inline">
          <button
            disabled={submitDisabled}
            className="btn btn-hero btn-primary submit"
            onClick={this.onSubmit}
          >
            {i18n.getString('Recommendation_Feedback_Submit_Action')}
          </button>
        </div>
        {!isAccountSettings && <div className="checkbox preference"><label htmlFor="checkbox_notshowagainn"><input id="checkbox_notshowagain" value={this.state.notshowagain} onChange={this.onPreferenceChange} type="checkbox" />{i18n.getString('Recommendation_Dismiss_Feedback_DontShowAgain')}</label></div>}
      </div>
    );
  }
}
